// write a function with jquery on document ready
jQuery(document).ready(function($) {
  console.log('Dudley Ventures Scripts loaded v1.0');




}); // end of document ready

